module.exports = __webpack_public_path__ + "img/ag.f6b94a14.svg";